import { render, staticRenderFns } from "./ScratchpadTab.vue?vue&type=template&id=6c5a29f8"
import script from "./ScratchpadTab.vue?vue&type=script&lang=js"
export * from "./ScratchpadTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports